import { CouponItem } from '@shopby/shop-sdk';
import { addDays, format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TargetCouponType } from '../../@types/coupon';
import { getTarget } from '../../api/coupons';
import { fadeIn, fadeOut } from '../../js/animation';
import { plusComma } from '../../js/script';

/**
 * 모달 팝업 - 섬 모양
 *
 * @params content - 콘텐츠 내용
 */

export default function CouponModalCenter({
  setIsModal,
  item,
  selectCouponNo,
}: {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  item?: CouponItem[];
  selectCouponNo?: number;
}) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요
  const [couponContent, setCouponContent] = useState<any>([]);
  const [addDate, setAddDate] = useState<string>('');
  const [target, setTarget] = useState<TargetCouponType[]>([]);
  const [targetArray, setTargetArray] = useState<string[]>([]);

  const closeModal = () => {
    setClosing(true);

    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 280);
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    item?.map((el: any) => {
      if (el.couponNo === selectCouponNo) {
        setCouponContent(el);
      }
    });
  }, []);

  useEffect(() => {
    if (couponContent.length !== 0) {
      getTarget(couponContent.couponNo)
        .then((res) => {
          setTarget(res.data.items);
        })
        .catch((err) => console.log(err));
    }
  }, [couponContent]);

  useEffect(() => {
    if (target.length > 0) {
      const uniqueTargets: any = Array.from(new Set(target.map((el: any) => el.targetName)));
      setTargetArray(uniqueTargets);
    }
  }, [target]);

  useEffect(() => {
    if (couponContent) {
      const useDays = couponContent.useConstraint?.useDays;
      if (useDays !== undefined) {
        plusDate(useDays);
      }
    }
  }, [couponContent]);

  function plusDate(day: number) {
    const today = new Date();
    const addDay = addDays(today, day);
    const formattedDate = format(addDay, 'yyyy.MM.dd'); // 'yyyy.MM.dd' 형식으로 포맷팅
    setAddDate(formattedDate);
  }

  // if (!isModal) return null;
  return (
    <ModalWrap style={{ zIndex: 100, position: 'fixed' }}>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>사용 안내</p>
          <button onClick={closeModal}>
            <img src="../images/icon_close.png" alt="" />
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="scroll_wrap">
            <p>{couponContent.couponName}</p>
            <dl>
              <dt>사용기간</dt>
              <dd>
                {couponContent.dateInfo?.issueStartYmdt
                  ?.split(' ', 1)
                  .join('')
                  .replaceAll('-', '. ')
                  .replaceAll('. 0', '. ')}{' '}
                - {addDate.replaceAll('.', '. ').replaceAll('. 0', '. ')}
              </dd>
              <dd>
                {couponContent?.useEndYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}{' '}
              </dd>
            </dl>
            <dl>
              <dt>금액조건</dt>
              <dd>
                {couponContent.discountInfo?.discountAmt === null
                  ? `${plusComma(couponContent.useConstraint?.minSalePrice)}원 이상 구매 시 
                      ${plusComma(couponContent.discountInfo?.discountRate)}% 할인${
                      couponContent.discountInfo?.maxDiscountAmt !== null
                        ? `(최대${plusComma(couponContent.discountInfo?.maxDiscountAmt)}원 할인)`
                        : null
                    }`
                  : `${plusComma(couponContent.useConstraint?.minSalePrice)}원 이상 구매 시 
                      ${plusComma(couponContent.discountInfo?.discountAmt)}원 할인`}
              </dd>
            </dl>
            <dl>
              <dt>적용상품</dt>
              <dd>
                {couponContent.couponType === 'PRODUCT'
                  ? couponContent.couponTargetType === 'ALL_PRODUCT'
                    ? '전체 상품'
                    : targetArray.join(',')
                  : '주문 전체'}
              </dd>
            </dl>
          </div>
        </ModalBody>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}

interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  margin: 0 20px;
  background-color: var(--colWhite);
  padding: 0;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
  position: relative;
  z-index: 30;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  @media screen and (min-width: 768px) {
    width: 480px;
    margin: 0;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 18.5px 22px 0 33px;
  & p {
    flex: 1;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
  & button {
    border: 0;
    padding: 0;
    margin: 0;
    background: transparent;
    width: 48px;
    height: 48px;
    padding: 12px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and (min-width: 768px) {
    padding: 6px 4px 6px 20px;
  }
`;

export const ModalBody = styled.div`
  & .scroll_wrap {
    overflow-y: auto;
    padding: 8px 33px 33px 33px;
    max-height: 274px;

    & p {
      margin-bottom: 4px;
      font-size: 15px;
      font-weight: 600;
      line-height: 24px;
      color: var(--colBlack);
    }
    & dl {
      margin-bottom: 3px;

      & dt {
        display: inline;
        font-size: 13px;
        line-height: 20px;
        font-weight: 600;
        color: var(--colGray6);
        margin-right: 6px;
      }
      & dd {
        display: inline;
        font-size: 13px;
        line-height: 20px;
        font-weight: 400;
        color: var(--colGray6);
      }
    }
    @media screen and (min-width: 768px) {
      padding: 0 20px 20px 20px;
      & p {
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: var(--colBlack);
      }
      & dl {
        margin-bottom: 6px;
        & dt {
          display: inline;
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          color: var(--colGray6);
          margin-right: 6px;
        }
        & dd {
          display: inline;
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
          color: var(--colGray6);
        }
      }
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;
